import React, {useState} from "react";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import ReactSelect from "../../UI/ReactSelect";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate,setFilterInputs,deviceModelId } = props;
  const [chooseOption, setChooseOption] = useState([]);

  function handleChangeModel(value) {
    setChooseOption(value);
    filterInputsUpdate("modelId", value.value);

  }
  const onResetFilter = () => {
    setFilterInputs({
      modelId: ""
    });
    setChooseOption(null)
    onHide(false)

  }
  return (
    <Modal
      size="md"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Qurğu modellərinin filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
          <div className="col-12 col-md-12 col-lg-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceModelId}
                  handleChangeSingle={(value) => handleChangeModel(value)}
                  single={chooseOption}
                  label="Model  seçin"
                  placeholder="Model seçin"
                  inputId="deviceModelId"
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">  <Button
          variant="primary"
          onClick={() => {
            onResetFilter();
          }}
          className="mt-4"
        >
         Sıfırla
        </Button>
        <Button
          variant="success"
          onClick={() => {
            onHide(false);
          }}
          className="mt-4 ml-4"
        >
         Tamam
        </Button></div>
        
        </div>
      </Modal.Body>
    </Modal>
  );
}
